import FormPresupuesto from "../componentes/FormPresupuesto.vue";
import ListaPresupuesto from "../componentes/ListaPresupuesto.vue";
import PresupuestoStepper from "../componentes/PresupuestoStepper.vue";
const meta_potencial = {
    Auth: true,
    rol: [1,2],
    lista: "lista-presupuesto-potencial",
    form: "guardar-presupuesto-potencial",
};
const meta_cliente = {
    Auth: true,
    rol: 2,
    lista: "lista-presupuesto-cliente",
    form: "guardar-presupuesto-cliente",
};
const meta_todo = {
    Auth: true,
    lista: "lista-presupuesto",
    form: "guardar-presupuesto",
};

const routes = [
    ...route("/guardar-presupuesto-potencial", FormPresupuesto, meta_potencial),
    ...route("/guardar-presupuesto-cliente", FormPresupuesto, meta_cliente),
    ...route("/guardar-presupuesto", FormPresupuesto, meta_todo),
    ...route("/lista-presupuesto-potencial", ListaPresupuesto, meta_potencial),
    ...route("/lista-presupuesto-cliente", ListaPresupuesto, meta_cliente),
    ...route("/lista-presupuesto", ListaPresupuesto, meta_todo),
    ...route("/stepper-presupuesto", PresupuestoStepper, {
        Auth: true,
        //req_admin: true
    }),
];

function route(path, component = Default, meta = {}) {
    return [
        {
            path,
            component,
            meta,
        },
    ];
}

export default routes;
